// Boxed figure with its caption underneath.

import { cn } from '@/lib/utils';

export function StatTile({ value, label, bordered }: { value: string; label: string; bordered?: boolean }) {
  return (
    <div
      className={cn(
        'flex flex-col gap-1 rounded-lg bg-gray-100 p-2',
        bordered ? 'items-end justify-center border border-gray-200 p-1.5' : 'min-w-0 flex-1 items-start',
      )}
    >
      <p className="text-[14px] font-semibold leading-[1.1] text-text-prose">{value}</p>
      <p className="whitespace-nowrap text-[12px] leading-[1.1] text-gray-800">{label}</p>
    </div>
  );
}
